module.exports = __webpack_public_path__ + "img/一个不会被@2x.d30ffc02.png";